module.exports = __webpack_public_path__ + "static/media/icon-05.dc30c480.png";